import { useEffect } from 'react';
import { usePageView } from '@/hooks/usePageView';
import { initErrorHandlers } from '@/lib/ops/error-handler';

export function PageViewTracker() {
  usePageView();

  useEffect(() => {
    // Initialize global error handlers
    initErrorHandlers();
  }, []);

  return null;
}

